import React from "react";
import { Form } from "react-bootstrap";

function CovidRiskCheckerQuestionnaire({questionnaire}) {
  return (
    <div>      
      {questionnaire.length > 0 && 
      <div className="pb-1">
        <div className="section-title">PATIENT QUESTIONNAIRE</div>
        <div>
          <div className="d-flex questionnaire-row">
              <label className="col-4 field-label">Are you over 18 years old?</label>
              <div className="col-8">
                <Form.Control type="text" value={questionnaire[0].answer} className="symptoms-field disabled-field" disabled/>
              </div>
          </div>
          <div className="d-flex questionnaire-row">
              <label className="col-4 field-label">Have you taken a COVID-19 self-test?</label>
              <div className="col-8">
                <Form.Control type="text" value={questionnaire[1].answer}  className="symptoms-field disabled-field" disabled/>
              </div>
          </div>
          <div className="d-flex questionnaire-row">
              <label className="col-4 field-label">Please upload your self-test result</label>
              <div className="col-8">
                <a href={questionnaire[2]?.image} className="url-field" target="_blank" rel="noreferrer noopener">{questionnaire[2]?.image.split('/').pop()}</a>
              </div>
          </div>
        </div>
      </div>
      }
    </div>
  );
}

export default CovidRiskCheckerQuestionnaire;
